<script>
import { Bar } from "vue-chartjs";
import utils from "../../../services/utils";
export default {
  extends: Bar,
  props: ["targetsData", "currentData", "labels", "title"],
  data() {
    return {
      options: {
        legend: {
          position: "top"
        },
        title: {
          display: true,
          text: this.title
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    };
  },
  computed: {
    data() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "Target",
            backgroundColor: utils.colors.blue,
            data: this.targetsData
          },
          {
            label: "Realized",
            backgroundColor: utils.colors.purple,
            data: this.currentData
          }
        ]
      };
    }
  },
  mounted() {
    this.renderChart(this.data, this.options);
  }
};
</script>
